import React from 'react';

const PrivacyPolicy = () => {
  return (
    <section className="bg-white py-16">
      <div className="mx-auto max-w-4xl space-y-8 px-6">
        <h1 className="text-3xl font-bold text-slate-900">Privacy Policy</h1>
        <p className="text-slate-600">
          At Dial TPR we coordinate orders between neighbourhood customers, trusted shops, and our
          delivery executives. This Privacy Policy explains how we handle the limited information you
          share with us while using our call-first concierge and delivery service.
        </p>
        <div className="space-y-4">
          <div>
            <h2 className="text-xl font-semibold text-slate-900">Information we collect</h2>
            <p className="text-slate-600">
              We only record the details required to fulfil your request: your name, contact number,
              delivery address, preferred shops, and the order list you share over call, WhatsApp, or
              email. If you request an invoice copy or GST bill, we store the document for audit and
              accounting purposes.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold text-slate-900">How we use your information</h2>
            <p className="text-slate-600">
              The information is used strictly to coordinate with partner stores, confirm product
              availability, share order updates, and schedule delivery with our executives. We do not
              sell or rent your information, and we only share it with the specific shop or supplier
              needed to complete your order.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold text-slate-900">Data retention and security</h2>
            <p className="text-slate-600">
              Order details are retained for as long as required to complete delivery, settle
              payments, and resolve customer queries. Access to this data is restricted to trained
              Dial TPR staff, and we use encrypted tools to store contact logs, invoices, and delivery
              proofs. When retention is no longer necessary, the data is securely deleted.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold text-slate-900">Your choices</h2>
            <p className="text-slate-600">
              You can request updates to your stored details or ask for deletion of your order
              history by writing to{' '}
              <a className="text-emerald-600" href="mailto:dailtpr@gmail.com">
                dailtpr@gmail.com
              </a>
              . For billing compliance, some invoice copies may need to be retained, but we will
              communicate this clearly when you write to us.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold text-slate-900">Contact us</h2>
            <p className="text-slate-600">
              For any privacy concerns or clarifications about how we handle your data, please reach
              our operations desk at{' '}
              <a className="text-emerald-600" href="tel:+919629128356">
                +91 96291 28356
              </a>{' '}
              or email us at{' '}
              <a className="text-emerald-600" href="mailto:dailtpr@gmail.com">
                dailtpr@gmail.com
              </a>
              .
            </p>
          </div>
        </div>
        <p className="text-sm text-slate-500">Last updated: {new Date().toLocaleDateString()}</p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
